import React from "react";
import "./Testimonials.css";
import boy1 from "./HeroSection/assets/boy1.jpg";
import boy2 from "./HeroSection/assets/boy2.jpg";
import girl1 from "./HeroSection/assets/girl1.png";
import girl2 from "./HeroSection/assets/girl2.jpg";

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      quote: "This platform helped me find the perfect piano teacher!",
      author: "Sumanth Kumar",
      role: "Student",
      image: boy1,
      rating: 5,
    },
    {
      id: 2,
      quote: "I've doubled my income by offering consulting services here.",
      author: "Maura",
      role: "Business Consultant",
      image: girl1,
      rating: 4,
    },
    {
      id: 3,
      quote: "I found amazing art experts who guided me step by step!",
      author: "Merlin",
      role: "Visual Artist",
      image: girl2,
      rating: 5,
    },
    {
      id: 4,
      quote: "Having experts on-demand has boosted my skills in no time!",
      author: "Aaditya",
      role: "Tech Enthusiast",
      image: boy2,
      rating: 5,
    },
  ];

  // Helper to render star rating
  const renderStars = (count) => {
    const stars = [];
    for (let i = 0; i < count; i++) {
      stars.push(<span key={i}>★</span>);
    }
    return stars;
  };

  return (
    <section className="testimonials">
      <h2 className="section-title">What Our Users Say</h2>
      <div className="testimonials-grid">
        {testimonials.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card">
            {/* Display image if available */}
            {testimonial.image && (
              <div className="testimonial-image">
                <img src={testimonial.image} alt={testimonial.author} />
              </div>
            )}

            {/* Quote and rating */}
            <div className="testimonial-content">
              {testimonial.rating && (
                <div className="testimonial-rating">
                  {renderStars(testimonial.rating)}
                </div>
              )}

              <p className="quote">“{testimonial.quote}”</p>

              <div className="author-info">
                <p className="author-name">{testimonial.author}</p>
                <p className="author-role">{testimonial.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
